import React from "react";

import { useState, useRef } from "react";
import { Box, Image, Text, Stack } from "@chakra-ui/react";
import { BiFile } from "react-icons/bi";

export function ImagePicker({
  acceptImageType,
  demoIcon,
  demoText,
  demoText2,
  fileSize,
  type,
}) {
  const [image, setImage] = useState(null);
  const [imageType, setImageType] = useState(null);
  const fileInputRef = useRef(null);
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file.size <= fileSize) {
      //4000000 is equal to 4 MB
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      alert("File size must be less than 4MB");
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file.size <= fileSize) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageType(type);
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      alert("File size must be less than maximum size");
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <Box
      style={{
        border: "1px solid #cecece",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      }}
      bg="#F4F4F4"
      w={{ base: "160px", md: "200px", lg: "250px" }}
      h={{ base: "140px", md: "180px", lg: "180px" }}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={handleClick}
    >
      <input
        type="file"
        accept={acceptImageType}
        onChange={handleFileInputChange}
        ref={fileInputRef}
        style={{ display: "none" }}
      />
      {image ? (
        <>
          {imageType === "image" && (
            <Image
              src={image}
              alt="Uploaded Image"
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            />
          )}
          {imageType === "doc" && (
            <Stack alignItems="center">
              <BiFile size="50px" />
              <Text fontSize="14px">
                {fileInputRef.current?.files[0]?.name}
              </Text>
            </Stack>
          )}
          {imageType === "video" && <video src={image} />}
        </>
      ) : (
        <Box fontWeight="semibold">
          <Box display={"flex"} justifyContent={"center"}>
            {demoIcon}
          </Box>
          <Text color={"#727272"}>{demoText}</Text>
          <Text color={"#008ddb"} fontSize={{ base: "16px", md: "20px" }}>
            {demoText2}
          </Text>
        </Box>
      )}
    </Box>
  );
}
